import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";

const useSentry = () => {
  const [isSentryLoaded, setIsSentryLoaded] = useState(false);

  useEffect(() => {
    const dsn = import.meta.env.VITE_SENTRY_DNS;
    let replaysSessionSampleRate = 1.0;
    let enabled = false;
    if (["production", "staging"].includes(import.meta.env.VITE_NODE_ENV)) {
      replaysSessionSampleRate = 0.1;
      enabled = true;
    }

    if (dsn && !isSentryLoaded && enabled) {
      Sentry.init({
        dsn,
        enabled,
        // release: sentryConfig.release, //Todo: add a release version
        environment: import.meta.env.VITE_NODE_ENV,
        integrations: [
          Sentry.browserTracingIntegration(),
          ...(import.meta.env.MODE === "production" ? [Sentry.replayIntegration()] : []),
        ],
        tracesSampler(samplingContext) {
          if (samplingContext.parentSampled !== undefined) {
            return samplingContext.parentSampled;
          }

          return 0.1;
        },
        replaysSessionSampleRate,
        replaysOnErrorSampleRate: 1.0,
        ignoreErrors: [
          /^Clarity/,
          // case of no network on user's device
          /TypeError: Network request failed/,
          // /ChunkLoadError/,
          /**
           * safe to ignore as these are
           * https://stackoverflow.com/questions/71280168/javascript-typeerror-load-failed-error-when-calling-fetch-on-ios
           */
          /TypeError: Load failed/,
          /TypeError: Failed to fetch dynamically imported module/,
          /TypeError: Importing a module script failed/,
          /TypeError: error loading dynamically imported module/,
          /TypeError: cancelled/,
        ],
        beforeSend(event) {
          // Check if the error is from Clarity based on the stack trace
          if (
            event?.exception?.values?.some((exception) =>
              exception?.stacktrace?.frames?.some(
                (frame) => frame?.filename?.includes("clarity.ms") || frame?.filename?.includes("clarity.js"),
              ),
            )
          ) {
            return null; // Drop the event
          }
          return event;
        },
        denyUrls: [
          // Chrome extensions
          /extensions\//i,
          /^chrome:\/\//i,
          // Clarity
          /clarity\.ms/,
          /www\.clarity\.ms/,
          /https:\/\/www\.clarity\.ms\//,
        ],
      });
      setIsSentryLoaded(true);
    }
    // if (user) {
    //   Sentry.setUser({
    //     id: user.userUuid,
    //     email: user.email,
    //     username: user.email,
    //   });
    //   Sentry.setTag("organization", user.organizationUuid);
    // }
  }, [isSentryLoaded, setIsSentryLoaded]);
};

export default useSentry;
